var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 45,
    viewBox: "0 0 40 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.0834 31.6593C29.332 30.2549 34 24.6726 34 18C34 10.268 27.732 4 20 4C12.268 4 6 10.268 6 18C6 24.6726 10.668 30.2549 16.9166 31.6593L20 37L23.0834 31.6593Z",
    strokeWidth: 3
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4466_16837)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.2 14.6626L21.08 14.0626C21.035 13.8326 20.83 13.6626 20.59 13.6626H17C16.725 13.6626 16.5 13.8876 16.5 14.1626V21.6626C16.5 21.9376 16.725 22.1626 17 22.1626C17.275 22.1626 17.5 21.9376 17.5 21.6626V18.6626H20.3L20.42 19.2626C20.465 19.4976 20.67 19.6626 20.91 19.6626H23.5C23.775 19.6626 24 19.4376 24 19.1626V15.1626C24 14.8876 23.775 14.6626 23.5 14.6626H21.2Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnd);
export default __webpack_public_path__ + "static/media/end.d2cae5485b419412c1870b7c583c15b0.svg";
export { ForwardRef as ReactComponent };